import type { Strain, StrainInput, StrainQuery } from '@shared';
import { strainsApi, type CatalogueMeta } from '../strainsApi';
import { ProductRepositoryError } from './errors';
import type { ProductRepository } from './types';

/**
 * Server/API-backed product repository. Delegates to existing strainsApi
 * without duplicating backend business logic.
 */
export function createServerProductRepository(
  api: typeof strainsApi = strainsApi,
): ProductRepository {
  return {
    mode: 'server',

    list: (query: Partial<StrainQuery> = {}) => api.list(query),
    meta: (): Promise<CatalogueMeta> => api.meta(),
    get: (id: string) => api.get(id),
    create: (input: StrainInput) => api.create(input),
    update: (id: string, input: StrainInput) => api.update(id, input),
    archive: (id: string, archived: boolean) => api.archive(id, archived),
    setVerified: (id: string, verified: boolean) =>
      api.setVerified(id, verified),
    duplicate: (id: string) => api.duplicate(id),
    remove: (id: string) => api.remove(id),
    fieldSources: (id: string) => api.fieldSources(id),
    importFromCatalogueBootstrap: async (_mapped: Strain): Promise<Strain> => {
      throw new ProductRepositoryError(
        'Catalogue bootstrap import is only available in local product repository mode.',
        { code: 'invalid_mode', status: 400 },
      );
    },
  };
}
